import React from "react";

function Button({content, size, colour, onClick, styles, disabled, style}) {

    const defaultSize = "";
    const defaultColour = "btn-tota";

    const classes = `btn ${size ? size : defaultSize} ${colour ? colour : defaultColour} ${styles}`;

    return (
        <button className={classes} onClick={onClick} disabled={{disabled}} disabled={disabled} style={style}>
            {content}
        </button>
    );

}

export default Button;
